import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Item from 'antd/lib/list/Item';

import { EntityMaterialSubCategoryApi, FindOptions } from 'api';
import { RootState } from 'app';

export const filterEntityMaterialSubCategory = createAsyncThunk(
  'entityMaterialSubCategory/filterEntityMaterialSubCategory',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialSubCategoryApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityMaterialSubCategory = createAsyncThunk(
  'entityMaterialSubCategory/createEntityMaterialSubCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialSubCategoryApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityMaterialSubCategory = createAsyncThunk(
  'entityMaterialSubCategory/findOneEntityMaterialSubCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntityMaterialSubCategoryApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityMaterialSubCategory = createAsyncThunk(
  'entityMaterialSubCategory/updateEntityMaterialSubCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityMaterialSubCategoryApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityMaterialSubCategoryStatus = createAsyncThunk(
  'entityMaterial/updateEntityMaterialStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityMaterialSubCategoryApi.updateStatus(
        id,
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityMaterialSubCategory = createAsyncThunk(
  'entityMaterialSubCategory/deleteEntityMaterialSubCategory',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialSubCategoryApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);
interface EntityMaterialSubCategoryState {
  tableList: Array<any>;
  isLoaded: boolean;
  savedList: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  entityMaterialSubCategoriesHash: any;
}

const initialState: EntityMaterialSubCategoryState = {
  tableList: [],
  isLoaded: false,
  savedList: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  entityMaterialSubCategoriesHash: {},
};

const entityMaterialCategorySlice = createSlice({
  name: 'entityMaterialSubCategory',
  initialState,
  reducers: {
    reloadEntityMaterialSubCategory(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityMaterialSubCategory(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityMaterialSubCategory(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      filterEntityMaterialSubCategory.fulfilled,
      (state, action) => {
        const { data } = action.payload;

        (data || []).forEach((e: any) => {
          const entityMaterialSubCategories =
            e.entityMaterialSubCategories?.map((item: any) => {
              return {
                ...Item,
                key: item.id,
                value: item.id,
                name: item.name,
              };
            });

          state.entityMaterialSubCategoriesHash[e.id] =
            entityMaterialSubCategories;
        });

        const newData = (data || []).map((item: any) => {
          return {
            ...Item,
            key: item.id,
            value: item.id,
            name: item.name,
          };
        });

        state.tableList = newData;
      }
    );
  },
});

const { actions, reducer: entityMaterialSubCategoryReducer } =
  entityMaterialCategorySlice;

export const {
  reloadEntityMaterialSubCategory,
  updateSavedPaginationEntityMaterialSubCategory,
  updateSavedListEntityMaterialSubCategory,
} = actions;

export default entityMaterialSubCategoryReducer;

export const selectEntityMaterialSubCategory = (
  state: RootState
): EntityMaterialSubCategoryState =>
  state.entityMaterialSubCategory as EntityMaterialSubCategoryState;
